import { IngredientUnits } from '@/interfaces/models/ingredient';
import Image from '@/models/image';
import i18n from '@/translations/i18n';
import assetsUtils from '@/utils/url.utils';

export default class TransactionIngredient {
  public cost: number;
  public id: string;
  public image: Image = new Image();
  public name: string;
  public unit: IngredientUnits = IngredientUnits.GRAM;
  public unitCount: number;
  public count: number;

  public constructor(transactionIngredientProps: any) {
    this.cost = transactionIngredientProps.cost;
    this.id = transactionIngredientProps.id;
    this.image = transactionIngredientProps.image;
    this.name = transactionIngredientProps.name;
    this.unit = transactionIngredientProps.unit;
    this.unitCount = transactionIngredientProps.unitCount;
    this.count = transactionIngredientProps.count;
  }

  get preview(): URL {
    if (this.image && this.image.original && this.image.path) {
      return assetsUtils.generateAssetsUrl(this.image.path);
    }

    return require('../assets/images/product-placeholder.png');
  }

  get unitTranslate() {
    switch (this.unit) {
      case IngredientUnits.GRAM:
        return i18n.t('menu.ingredient.unitName.grams');
      case IngredientUnits.MILLILITER:
        return i18n.t('menu.ingredient.unitName.milliliters');
      default:
        return i18n.t('menu.ingredient.unitName.unit');
    }
  }
}
